import type { DragHandleProps } from '@ztechapps/webui.util'
import { DragHandle } from '@ztechapps/webui.util'
import React from 'react'
import { useHandleProps } from '../HandlePropsContext'

export const TableCellDragHandle = ({ disabled, title, As: _As, ...rest }: DragHandleProps) => {
  const handleProps = useHandleProps()
  return <DragHandle disabled={disabled} title={title} As="td" {...rest} {...handleProps} />
}
